import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import React from "react";
import { toast } from "react-toastify";
import { useDeleteDocument } from "../../../hooks/api/projectDocumentsApiHooks";

/**
 * Modal de confirmação para deletar documento
 * @param {object} props
 * @param {boolean} props.isOpen - Se o modal está aberto
 * @param {function} props.onClose - Callback ao fechar
 * @param {object} props.document - Documento a ser deletado
 * @param {function} props.onSuccess - Callback ao sucesso
 */
export default function DeleteConfirmationModal({ isOpen, onClose, document, onSuccess }) {
  const { mutateAsync: deleteDocument, isLoading } = useDeleteDocument();

  // Handler de confirmação de deleção
  const handleDelete = async () => {
    try {
      await deleteDocument(document.id);
      toast.success("Documento deletado com sucesso!");
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (error) {
      console.error("Erro ao deletar documento:", error);
      const errorMessage = error.response?.data?.message || "Erro ao deletar documento";
      toast.error(errorMessage);
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Confirmar Exclusão
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" disabled={isLoading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Tem certeza que deseja deletar este documento?
        </Typography>

        <Box
          sx={{
            p: 1.5,
            bgcolor: "background.default",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            {document?.documentType?.name || "Documento"}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            📄 {document?.fileName}
          </Typography>
        </Box>

        <Box
          sx={{
            mt: 2,
            p: 1.5,
            bgcolor: "warning.lighter",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "warning.main",
          }}
        >
          <Typography variant="body2" color="warning.dark">
            ⚠️ Esta ação não pode ser desfeita. O arquivo será removido permanentemente.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          disabled={isLoading}
        >
          {isLoading ? "Deletando..." : "Deletar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

